/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl, checkIsActive } from '../../../../_helpers';
import { usePermissions } from '../../../../../app/contexts/PermissionsContext';
import packageJson from '../../../../../../package.json';
import { shallowEqual, useSelector } from 'react-redux';
import { useDashboards } from '../../../../../app/contexts/DashboardContext';
import { injectIntl } from 'react-intl';

function AsideMenuListComponent({ layoutProps, setRemoveMargin, intl }) {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const { dashboards } = useDashboards();
  const containerRef = useRef();
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const [displayLogo, setNeedsDisplayLogo] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      const resizer = new ResizeObserver(() => {
        if (containerRef.current?.clientWidth < 100) {
          setRemoveMargin(true);
          setNeedsDisplayLogo(true);
        } else {
          setRemoveMargin(false);
          setNeedsDisplayLogo(false);
        }
      });
      resizer.observe(containerRef.current);

      return () => {
        resizer.disconnect();
      };
    }
  }, []);

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          'menu-item-active'} menu-item-open menu-item-not-hightlighted`
      : '';
  };

  return (
    <div
      className="d-flex flex-column h-100 justify-content-between"
      ref={containerRef}
    >
      <ul
        className={`menu-nav ${displayLogo && 'pt-0'} ${layoutProps.ulClasses}`}
      >
        {displayLogo && (
          <div className="d-flex flex-center mb-5">
            <img
              width={30}
              alt="Aurea lpgp"
              src={toAbsoluteUrl('/media/logos/senseworks-refresh-logo.png')}
            />
          </div>
        )}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            '/dashboard',
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG
                cacheRequests={true}
                src={toAbsoluteUrl('/media/svg/senseworks/dashboard-1.svg')}
              />
            </span>
            <span className="menu-text font-size-h6">Dashboard</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            {dashboards.map(dash => (
              <ul className="menu-subnav" key={dash.embeddedId}>
                <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span className="menu-text font-size-h6">
                      {dash.dashboard_title}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    `/dashboard/${dash.embeddedId}`
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to={`/dashboard/${dash.embeddedId}`}
                  >
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/dashboard-1.svg'
                        )}
                      />
                    </span>
                    <span className="menu-text font-size-h6">
                      {dash.dashboard_title}
                    </span>
                  </NavLink>
                </li>
              </ul>
            ))}
            {/* <ul className="menu-subnav" >
                        <li className="menu-item menu-item-parent" aria-haspopup="true">
                            <span className="menu-link">
                                <span className="menu-text font-size-h6">Flows</span>
                            </span>
                        </li>
                        <li
                            className={`menu-item ${getMenuItemActive(`/dashboard/flows`)}`}
                            aria-haspopup="true"
                        >
                            <NavLink className="menu-link" to={`/dashboard/flows`}>
                                <span className="svg-icon menu-icon">
                                    <SVG cacheRequests={true} src={toAbsoluteUrl("/media/svg/senseworks/dashboard-1.svg")} />
                                </span>
                                <span className="menu-text font-size-h6">Flows</span>
                            </NavLink>
                        </li>
                    </ul> */}
          </div>
        </li>

        {hasPermission('projects*', 'R') && (
          <li
            className={`menu-item ${getMenuItemActive('/projects', false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/projects">
              <span className="svg-icon menu-icon">
                <SVG
                  cacheRequests={true}
                  src={toAbsoluteUrl('/media/svg/senseworks/projects-menu.svg')}
                />
              </span>
              <span className="menu-text font-size-h6">Projects</span>
            </NavLink>
          </li>
        )}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            '/geo-planner',
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/geo-planner">
            <span className="svg-icon menu-icon">
              <SVG
                cacheRequests={true}
                src={toAbsoluteUrl('/media/svg/senseworks/geoplan.svg')}
              />
            </span>
            <span className="menu-text font-size-h6">Geo Planner</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item  menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text font-size-h6">Geo Planner</span>
                </span>
              </li>

              {hasPermission('areas*', 'R') && (
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/geo-planner/areas'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/geo-planner/areas">
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/area-map.svg'
                        )}
                      />
                    </span>
                    <span className="menu-text font-size-h6">Areas</span>
                  </NavLink>
                </li>
              )}

              {hasPermission('facilities*', 'R') && (
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/geo-planner/facilities'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/geo-planner/facilities">
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/facility.svg'
                        )}
                      />
                    </span>
                    <span className="menu-text font-size-h6">Facilities</span>
                  </NavLink>
                </li>
              )}

              {hasPermission('zones*', 'R') && (
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/geo-planner/zones'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/geo-planner/zones">
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl('/media/svg/senseworks/zone.svg')}
                      />
                    </span>
                    <span className="menu-text font-size-h6">Zones</span>
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </li>

        {hasPermission('processing-groups*', 'R') && (
          <li
            className={`menu-item ${getMenuItemActive(
              '/processing-groups',
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/processing-groups">
              <span className="svg-icon menu-icon">
                <SVG
                  cacheRequests={true}
                  src={toAbsoluteUrl(
                    '/media/svg/senseworks/processing-groups.svg'
                  )}
                />
              </span>
              <span className="menu-text font-size-h6">Processing Groups</span>
            </NavLink>
          </li>
        )}

        {hasPermission('flows*', 'R') && (
          <li
            className={`menu-item ${getMenuItemActive('/flows', false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/flows">
              <span className="svg-icon menu-icon">
                <SVG
                  cacheRequests={true}
                  src={toAbsoluteUrl('/media/svg/senseworks/edge-flows.svg')}
                />
              </span>
              <span className="menu-text font-size-h6">Flows</span>
            </NavLink>
          </li>
        )}

        {hasPermission('*', 'R') && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              '/assets-management',
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/assets-management">
              <span className="svg-icon menu-icon">
                <SVG
                  cacheRequests={true}
                  src={toAbsoluteUrl(
                    '/media/svg/senseworks/warehouse-package.svg'
                  )}
                />
              </span>
              <span className="menu-text font-size-h6">Assets Management</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span className="menu-text font-size-h6">
                      Assets Management
                    </span>
                  </span>
                </li>
                {hasPermission('asset-categories*', 'R') && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      '/assets-management/categories',
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/assets-management/categories"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          cacheRequests={true}
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/shipment-packages.svg'
                          )}
                        />
                      </span>
                      <span className="menu-text font-size-h6">Categories</span>
                    </NavLink>
                  </li>
                )}
                {hasPermission('assets*', 'R') && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      '/assets-management/assets'
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/assets-management/assets"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          cacheRequests={true}
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/shipment-box.svg'
                          )}
                        />
                      </span>
                      <span className="menu-text font-size-h6">Assets</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {hasPermission('*', 'R') && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              '/devices',
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/infrastructure">
              <span className="svg-icon menu-icon">
                <SVG
                  cacheRequests={true}
                  src={toAbsoluteUrl(
                    '/media/svg/senseworks/microchip-board.svg'
                  )}
                />
              </span>
              <span className="menu-text font-size-h6">
                {intl.formatMessage({ id: 'MENU.INFRASTRUCTURE' })}
              </span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span className="menu-text font-size-h6">Devices</span>
                  </span>
                </li>
                {hasPermission('edge-gateways*', 'R') && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      '/infrastructure/gateways',
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/infrastructure/gateways"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          cacheRequests={true}
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/gateways.svg'
                          )}
                        />
                      </span>
                      <span className="menu-text font-size-h6">
                        {intl.formatMessage({
                          id: 'MENU.INFRASTRUCTURE.EDGE_GATEWAYS',
                        })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {hasPermission('things*', 'R') && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      '/infrastructure/things'
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/infrastructure/things">
                      <span className="svg-icon menu-icon">
                        <SVG
                          cacheRequests={true}
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/wifi-signal-4.svg'
                          )}
                        />
                      </span>
                      <span className="menu-text font-size-h6">
                        {intl.formatMessage({
                          id: 'MENU.INFRASTRUCTURE.DEVICES',
                        })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {hasPermission('tags*', 'R') && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      '/infrastructure/tags'
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/infrastructure/tags">
                      <span className="svg-icon menu-icon">
                        <SVG
                          cacheRequests={true}
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/charging-wireless-charging.svg'
                          )}
                        />
                      </span>
                      <span className="menu-text font-size-h6">
                        {intl.formatMessage({ id: 'MENU.INFRASTRUCTURE.TAGS' })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {hasPermission('profiles*', 'R') && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      '/infrastructure/connectivity-profiles'
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/infrastructure/connectivity-profiles"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          cacheRequests={true}
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/cloud-connectivity.svg'
                          )}
                        />
                      </span>
                      <span className="menu-text font-size-h6">
                        {intl.formatMessage({
                          id: 'MENU.INFRASTRUCTURE.CONNECTIVITY',
                        })}
                      </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {hasPermission('applications*', 'R') && (
          <li
            className={`menu-item ${getMenuItemActive('/applications', false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/applications">
              <span className="svg-icon menu-icon">
                <SVG
                  cacheRequests={true}
                  src={toAbsoluteUrl('/media/svg/senseworks/puzzle.svg')}
                />
              </span>
              <span className="menu-text font-size-h6">Applications</span>
            </NavLink>
          </li>
        )}

        <li
          className={`menu-item ${getMenuItemActive('/account', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/account">
            <span className="svg-icon menu-icon">
              <SVG
                cacheRequests={true}
                src={toAbsoluteUrl('/media/svg/senseworks/user_1.svg')}
              />
            </span>
            <span className="menu-text font-size-h6">Account</span>
          </NavLink>
        </li>
        {user.isSuperAdmin && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              '/administration',
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/administration">
              <span className="svg-icon menu-icon">
                <SVG
                  cacheRequests={true}
                  src={toAbsoluteUrl(
                    '/media/svg/senseworks/shield-settings.svg'
                  )}
                />
              </span>
              <span className="menu-text font-size-h6">Administration</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span className="menu-text font-size-h6">
                      Administration
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/administration/business-entities'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/administration/business-entities"
                  >
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/briefcase_1.svg'
                        )}
                      />
                    </span>
                    <span className="menu-text font-size-h6">Accounts</span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/administration/edge-gateways'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/administration/edge-gateways"
                  >
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/setting-gateway.svg'
                        )}
                      />
                    </span>
                    <span className="menu-text font-size-h6">
                      Manage Edge Gateways{' '}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/administration/devices'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/administration/devices">
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/wifi-signal-4.svg'
                        )}
                      />
                    </span>
                    <span className="menu-text font-size-h6">
                      Manage Devices{' '}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/administration/tags'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/administration/tags">
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/charging-wireless-charging.svg'
                        )}
                      />
                    </span>
                    <span className="menu-text font-size-h6">Manage Tags </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/administration/greengrass-components'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/administration/greengrass-components"
                  >
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl('/media/svg/senseworks/puzzle.svg')}
                      />
                    </span>
                    <span className="menu-text font-size-h6">
                      Manage Components{' '}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    '/administration/models'
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/administration/models">
                    <span className="svg-icon menu-icon">
                      <SVG
                        cacheRequests={true}
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/microchip-board.svg'
                        )}
                      />
                    </span>
                    <span className="menu-text font-size-h6">
                      Manage Firmware
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )}
      </ul>
      <span
        className="font-size-h6"
        style={{ textAlign: 'center', color: '#778689' }}
      >
        Version {packageJson.version}
      </span>
    </div>
  );
}

export const AsideMenuList = injectIntl(AsideMenuListComponent);
